const constants = {
  csMailAddress: 'thezib@kevoting.com',
};

export default constants;
